<script>
import { uniqBy } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import AjoutRapideAuPanier from './ajout-rapide-au-panier';
import { format } from 'date-fns';

const NB_LIGNES_AFFICHEE_MOBILE = 12;

export default {
  name: 'OrderHistory',
  components: {
    AjoutRapideAuPanier
  },
  data: () => ({
    currentLigne: null,
    modal: false,
    modalKey: 0,
    loaderModal: false,
    indexLigneMaxAffichee: null,
    finHistoriqueAtteind: false,
    afficherPlusLivraisonsLoading: false,
    modalDate: false,
    modalDateKey: 0,
    loading: true,
    lignesDupl: [],
    modeSelection: false,
    numAdresseChoisie: null
  }),
  computed: {
    ...mapGetters({
      tiers: 'user/tiers',
      ref: 'referentiel/referentiel',
      paramsCommande: 'referentiel/paramsCommande',
      historiqueLivraisons: 'commandes/historiqueLivraisons'
    }),
    adresseTiers () {
      return uniqBy(
        this.historiqueLivraisons.map(item => ({
          value: item.numAdresse,
          text: `${item.numAdresse}`
        })),
        'value'
      );
    },
    affichefiltreAdresses () {
      return this.adresseTiers.length > 1;
    },
    // filtres () {
    //  const filtres = [
    //    { text: 'tous', active: true },
    //    { text: 'Ruminant', active: false },
    //    { text: 'Volaille', active: false },
    //    { text: 'Porc', active: false }
    //  ];

    //  if (this.isMobile) {
    //    return filtres.filter(f => f.active);
    //  }
    //   return filtres;
    // },
    lignesCommandes () {
      const historiqueLivraisons = (this.historiqueLivraisons || [])
        .filter(item =>
          this.numAdresseChoisie === undefined || this.numAdresseChoisie === null || item.numAdresse === this.numAdresseChoisie
        );
      if (this.isMobile) {
        return historiqueLivraisons.slice(0, this.indexLigneMaxAffichee);
      } else {
        return historiqueLivraisons;
      }
    }
  },
  created () {
    this.loadHistoriqueLivraisons(this.tiers.numTiers).then(livraisons => {
      this.finHistoriqueAtteind = !livraisons.length;
      if (this.isMobile) {
        this.fixNbLigneAfficheesMobile();
      }
    }).finally(() => {
      setTimeout(() => { this.loading = false; }, 50);
    });
    this.indexLigneMaxAffichee = this.isMobile ? NB_LIGNES_AFFICHEE_MOBILE : -1;

    const param = {
      typeTiers: this.tiers.typeTiers,
      numTiers: this.tiers.numTiers,
      numEntite: 'AGR',
      dateValidite: format(new Date(), 'yyyy-MM-dd')
    };
    this.loadContrats(param); // used in cards
  },
  methods: {
    ...mapActions({
      addLineToCart: 'cart/addLine',
      loadParamsCommande: 'referentiel/loadParamsCommande',
      loadHistoriqueLivraisons: 'commandes/loadHistoriqueLivraisons',
      loadSuiteHistoriqueLivraisons: 'commandes/loadSuiteHistoriqueLivraisons',
      loadContrats: 'contrats/loadContrats'
    }),
    commandeLigne (ligne) {
      this.currentLigne = ligne;
      this.modal = true;
      this.modalKey++;
    },
    addToCart (ligne) {
      this.modal = false;
      this.addLineToCart(ligne);
      setTimeout(() => {
        this.$dialog.confirm({
          text: '<i aria-hidden="true" style="font-size:42px;" class="v-icon notranslate mdi mdi-check-circle-outline theme--light"></i><br/>Le produit a été ajouté à votre panier',
          actions: {
            continuer: { text: 'Continuer mes achats ', flat: false },
            panier: { text: 'Voir mon panier', color: 'primary', flat: false }
          }
        }).then(
          result => {
            if (result === 'panier') {
              this.$router.push({ name: 'main.catalog.cart' });
            }
          }
        );
      });
    },
    appelDuplication () {
      this.modalDate = true;
    },
    closeModalDupplication () {
      this.modalDate = false;
      this.toogleModeSelection(false);
    },
    fixNbLigneAfficheesMobile () {
      // on etend le nbre de ligne affichée pour ne pas couper une date
      if (this.indexLigneMaxAffichee >= this.historiqueLivraisons.length) {
        return;
      }

      const lignesRestantes = this.historiqueLivraisons.slice(this.indexLigneMaxAffichee);
      const lastdate = this.lignesCommandes.slice(-1)[0].dateEffectiveLivraison;
      for (const i in lignesRestantes) {
        if (lignesRestantes[i].dateEffectiveLivraison === lastdate) {
          this.indexLigneMaxAffichee += 1;
        } else {
          break;
        }
      }

      this.$forceUpdate();
    },
    afficherPlusLivraisons () {
      if (this.isMobile && this.indexLigneMaxAffichee + NB_LIGNES_AFFICHEE_MOBILE <= this.historiqueLivraisons.length) {
        // on a deja suffisament de ligne en memoire, on affiche la suite
        this.indexLigneMaxAffichee += NB_LIGNES_AFFICHEE_MOBILE;
        this.fixNbLigneAfficheesMobile();
      } else {
        // pas assez de ligne en memoire -> chargement
        this.afficherPlusLivraisonsLoading = true;
        this.loadSuiteHistoriqueLivraisons(this.tiers.numTiers).then(livraisons => {
          this.afficherPlusLivraisonsLoading = false;
          if (this.isMobile) {
            this.indexLigneMaxAffichee += NB_LIGNES_AFFICHEE_MOBILE;
            this.fixNbLigneAfficheesMobile();
          }
          if (livraisons.length === 0) {
            this.finHistoriqueAtteind = true;
          }
        });
      }
    },
    redirectionLotsPlans (ligne) {
      this.$router.push({ name: 'main.catalog.lots', query: { numExploitation: ligne.numExploitation, numBatiment: ligne.numBatiment, numLot: ligne.numLot } });
    },
    toogleSelect (ligne) {
      const index = this.lignesDupl.indexOf(ligne);
      if (~index) {
        this.lignesDupl.splice(index, 1);
      } else {
        this.lignesDupl.push(ligne);
      }
    },
    isSelected (ligne) {
      return !!~this.lignesDupl.indexOf(ligne);
    },
    toogleModeSelection (forceState) {
      this.lignesDupl = [];
      this.modeSelection = forceState !== undefined ? forceState : !this.modeSelection;
    },
    canDuplicate (ligne) {
      return ligne.numAdr || ligne.numAdresse || ligne.numeroAdresse || ligne.numExploitation || ligne.numeroExploitation;
    },
    rechAdresse () {
      return this.historiqueLivraisons.filter(a => a.numAdr === this.numAdresseChoisie);
    }
  }
};
</script>
<template>
  <Loader v-if="loading" />
  <div v-else>
    <div>
      <h2 class="primary--text">
        <span v-if="!modeSelection">Historique des livraisons

          <CardsHelp
            :page="'HISTORIQUE'"
            :niveau="'TITRE'"
          />

        </span>
        <span v-else>Ajouter des aliments au panier</span>
      </h2>
      <div
        v-if="lignesCommandes && lignesCommandes.length"
        class="entete"
      >
        <div>
          <div
            v-if="!modeSelection"
            class=" white--text duplication-container"
          >
            <v-btn
              class="action-btn"
              color="secondary"
              @click="toogleModeSelection()"
            >
              <span class="action-btn-text">Duplication</span>

              <v-icon color="white">
                mdi-cart-plus
              </v-icon>
            </v-btn>
          </div>
          <div
            v-else
            class="bloc-duplication"
          >
            <v-btn
              class="ma-3"
              outlined
              @click="toogleModeSelection()"
            >
              Annuler
            </v-btn>
            <v-btn
              class="ma-3"
              :disabled="lignesDupl.length === 0"
              @click="appelDuplication()"
            >
              Valider la sélection ({{ lignesDupl.length }})
            </v-btn>
          </div>
        </div>

        <div class="entete-spacer" />
        <div
          v-if="affichefiltreAdresses"
          id="adresses-list"
        >
          <v-select
            v-model="numAdresseChoisie"
            :items="[{value:null, text:'Toutes'}].concat(adresseTiers)"
            label="Adresse de livraison"
            class="select-adresses"
            attach="#adresses-list"
            hide-details
            @click="rechAdresse()"
          >
            <template v-slot:item="{item}">
              <span>•</span>
              <span v-if="item.value===null">Toutes les adresses de livraison</span>
              <RefValue
                v-else
                :code="item.value"
                type="ADRESSE"
              />
            </template>
            <template v-slot:selection="{item}">
              <span v-if="item.value===null">Toutes les adresses de livraison</span>
              <RefValue
                v-else
                class="py-2"
                :code="item.value"
                type="ADRESSE"
              />
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <!-- <v-tabs
      v-if="filtres.length > 1"
      show-arrows
      color="primary"
      background-color="transparent"
    >
      <v-tab
        v-for="filtre in filtres"
        :key="filtre.text"
        :disabled="!filtre.active"
      >
        {{ filtre.text }}
      </v-tab>
    </v-tabs> -->

    <CardsList
      :items="lignesCommandes"
      :group-by="item=>item.dateEffectiveLivraison"
    >
      <template v-slot:empty>
        Aucune livraison à afficher
      </template>
      <template v-slot:groupTitle="{group}">
        {{ group | date }}
      </template>
      <template v-slot:item="{item}">
        <CardsListItemLigneCommande :ligne="item">
          <template v-slot:actions="{ligne}">
            <v-btn
              v-if="ligne.artCommandable && tiers.hasLots && ligne.codeFamilleArticle.startsWith('45')"
              color="secondary"
              class="action-btn"
              outlined
              :disabled="modeSelection"
              @click="redirectionLotsPlans(ligne)"
            >
              <span
                v-if="!isMobile"
                class="action-btn-text ml-1"
              >Lots &amp;<br>plans</span>
              <v-icon>$vuetify.icons.chicken</v-icon>
            </v-btn>
            <template v-else-if="modeSelection">
              <v-btn
                v-if="!isSelected(ligne)"
                class="action-btn"
                :disabled="!ligne.artCommandable || !canDuplicate(ligne)"
                color="secondary"
                @click="toogleSelect(ligne)"
              >
                <span
                  v-if="!isMobile"
                  class="action-btn-text"
                >Ajouter</span>
                <v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-btn
                v-else
                class="action-btn white--text"
                :disabled="!ligne.artCommandable"
                color="success"
                @click="toogleSelect(ligne)"
              >
                <span
                  v-if="!isMobile"
                  class="action-btn-text"
                >Ajouté</span>
                <v-icon>
                  mdi-check
                </v-icon>
              </v-btn>
            </template>

            <v-btn
              v-else
              class="action-btn"
              :disabled="!ligne.artCommandable"
              color="secondary"
              @click="commandeLigne(ligne)"
            >
              <span
                v-if="!isMobile"
                class="action-btn-text"
              >Ajouter</span>
              <v-icon>
                mdi-cart-outline
              </v-icon>
            </v-btn>
          </template>
        </CardsListItemLigneCommande>
      </template>
    </CardsList>
    <div class="center afficher-plus-container">
      <v-btn
        v-if="!finHistoriqueAtteind"
        :block="isMobile"
        :loading="afficherPlusLivraisonsLoading"
        outlined
        @click="afficherPlusLivraisons()"
      >
        Afficher plus de livraisons
      </v-btn>
      <span v-else>
        Impossible d’afficher plus de livraisons
      </span>
    </div>

    <v-dialog
      v-model="modal"
      transition="dialog-bottom-transition"
      :fullscreen="isMobile"
      persistent
      scrollable
    >
      <LineEdit
        v-if="modal"
        :key="modalKey"
        :line="currentLigne"
        is-ajout
        @cancel="modal=false"
        @validate="addToCart"
      />
    </v-dialog>

    <v-dialog
      v-model="modalDate"
      :width="isMobile ? '95%' : '60em'"
      transition="dialog-bottom-transition"
      persistent
      scrollable
    >
      <AjoutRapideAuPanier
        v-if="modalDate"
        :lignes="lignesDupl"
        @cancel="closeModalDupplication()"
        @validate="closeModalDupplication()"
      />
    </v-dialog>

    <Loader
      :loading="loaderModal"
      dialog
    />
  </div>
</template>

<style lang="scss" scoped>
.afficher-plus-container {
  margin-top: 1em;
}

.action-btn-text {
  margin-right: 8px;
}

.duplication-container {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0.8em 1.8em;
  font-weight: 400;
  font-size: 1.15em;
  height: auto;
  .v-btn {
    margin-left: 1em;
  }
  margin-bottom: 10px;
}

.entete-spacer {
  width: 40px;
  height: 1px;
}

.select-adresses {
  max-width: 1200px;
  min-width: 50vw;
  ::v-deep input {
    display: none;
  }
}

.entete {
  display: inline-flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  & > *:last-child {
    flex: 1;
  }
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .duplication-container {
    display: inline-flex;
    // width: 100%;
    justify-content: space-around;
    padding: 0.3em 1em;
  }
  .v-btn.action-btn {
    min-width: 0;
  }

  .entete {
    display: inline-flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }

  .select-adresses {
    margin-top: 10px;
    margin-left: 0px;
  }

  .bloc-duplication {
    max-width: 100%;
    width: 100%;
    margin: 0;
    display: flex;
    flex-direction: row-reverse;
    flex-flow: column-reverse wrap;
  }
}

#adresses-list{
  position: relative;
}
@media #{map-get($display-breakpoints, 'xs-only')}{
  #adresses-list{
    width: 100%;
  }
}

#adresses-list ::v-deep .v-list-item{
  align-items: flex-start;
  &>span{
    margin-right: 10px;;
  }
}
#adresses-list ::v-deep .v-list-item:nth-child(2n){
  background-color: #eee;
}
</style>
